import { Component } from '@angular/core';

@Component({
  selector: 'opac-card-item-details',
  templateUrl: './card-item-details.component.html',
  styleUrls: ['./card-item-details.component.scss']
})
export class CardItemDetailsComponent {
}
